import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import adminRoutes from './adminRoutes';
import Layout from './Layout';
import CheckInGate from '../components/CheckInGate';
import AdminLogin from '../pages/AdminLogin';
import NotFound from '../pages/NotFound';
import AuthService from '../services/AuthService';
import Forbidden from '../pages/Forbidden';
import { hasPermission, getDefaultAdminRoute } from '../utils/permissions';
import Home from '../pages/landing/Home';
import TermsCondition from '../pages/landing/TermsAndConditions';
import Privacy from '../pages/landing/PrivacyPolicy';
import CancellationPolicy from '../pages/landing/CancellationPolicy';
import WebViewDemo from '../pages/WebViewDemo';

const AppRouter = () => {
    const isAdminAuthenticated = !!AuthService.getCurrentUser();
    const basePath = process.env.REACT_APP_BASE_PATH;

    return (
        <Router basename={basePath}>
            {/* Mounted once for the whole app session — gates every admin portal
                route behind a mandatory Check In prompt for staff, but never the
                public site or the login screen. */}
            <CheckInGate>
                <Routes>
                    {/* Public marketing site */}
                    <Route path="/" element={<Home />} />
                    <Route path="/terms" element={<TermsCondition />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/cancellation-policy" element={<CancellationPolicy />} />

                    {/* Demo */}
                    <Route path="/webview-demo" element={<WebViewDemo />} />

                    {/* Legacy redirects */}
                    <Route path="/dashboard" element={<Navigate to={getDefaultAdminRoute()} />} />
                    <Route path="/login" element={<Navigate to="/admin/login" />} />

                    {/* Admin login */}
                    <Route path="/admin/login" element={
                        <Layout hideHeader={true} hasPermission={true}>
                            <AdminLogin />
                        </Layout>
                    } />

                    {/* Admin portal routes */}
                    <Route path="/admin" element={<Navigate to={getDefaultAdminRoute()} />} />
                    {adminRoutes.map((route, index) => {
                        const Component = route.component;
                        // A role that lacks the route's permission gets the same
                        // treatment whether it arrived by menu or by typing the URL.
                        const permitted = hasPermission(route.meta.permission);
                        return (
                            <Route
                                key={`admin-${index}`}
                                path={route.path}
                                element={
                                    route.meta.requiresAuth && !isAdminAuthenticated ? (
                                        <Navigate to="/admin/login" />
                                    ) : (
                                        <Layout hideHeader={false} hasPermission={permitted}>
                                            {permitted ? <Component /> : <Forbidden />}
                                        </Layout>
                                    )
                                }
                            />
                        );
                    })}

                    {/* 404 */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </CheckInGate>
        </Router>
    );
};

export default AppRouter;
